import classNames from "classnames"
import PropTypes from "prop-types"
import React from "react"

import SectionWithImage from "../section-with-image/section-with-image"
import "./text-with-image.sass"

class TextWithImage extends React.Component {
  render() {
    return (
      <SectionWithImage {...this.props}>
        <div className={classNames("_fp-text-with-image")}>
          <h3 className={"_fp-heading-1 _fp-text-with-image__text__title"}>
            {this.props.title}
          </h3>
          <p className={"_fp-text _fp-text-with-image__text__copy"}>
            {this.props.copy}
          </p>
        </div>
      </SectionWithImage>
    )
  }
}

TextWithImage.propTypes = {
  ...SectionWithImage.propTypes,
  copy: PropTypes.string,
  title: PropTypes.string,
}

TextWithImage.defaultProps = {
  ...SectionWithImage.defaultProps,
  center: true,
}

export default TextWithImage
